<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card style="padding:20px 50px">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">
        <h4  style="color:var(--medium-blue)"> <i class="mdi mdi-alert"></i> O animal está sem data de nascimento.</h4> 
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p> 
          O animal está sem data de nascimento. Por favor, envie um email com a 
          cópia de registro para <strong>genealogia@jersey.com.br</strong> para que a data de nascimento 
          seja cadastrada
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAlertBornAt",
  props:{
    active:Boolean
  }
}
</script>

<style scoped>
  .close-icon {
    right: 50px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>